// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  min-height: 100vh;
}

/* Marquee animation for client logos */
@keyframes marquee {
  0% { transform: translateX(0); }
  100% { transform: translateX(-50%); }
}
.animate-marquee {
  animation: marquee 30s linear infinite;
}

/* Subtle dotted background for sections */
.bg-dots {
  background-image: radial-gradient(rgba(15, 23, 42, 0.06) 1px, transparent 1px);
  background-size: 24px 24px;
}

/* Gradient text helper */
.text-gradient-green {
  background: linear-gradient(90deg, #25D366 0%, #128C7E 100%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

/* Soft glow */
.glow-green {
  box-shadow: 0 20px 60px -20px rgba(37, 211, 102, 0.45);
}

/* Smooth scroll for in-page anchors */
html { scroll-behavior: smooth; }
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA,uCAAuC;AACvC;EACE,KAAK,wBAAwB,EAAE;EAC/B,OAAO,2BAA2B,EAAE;AACtC;AACA;EACE,sCAAsC;AACxC;;AAEA,0CAA0C;AAC1C;EACE,8EAA8E;EAC9E,0BAA0B;AAC5B;;AAEA,yBAAyB;AACzB;EACE,4DAA4D;EAC5D,6BAA6B;EAC7B,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA,cAAc;AACd;EACE,sDAAsD;AACxD;;AAEA,sCAAsC;AACtC,OAAO,uBAAuB,EAAE","sourcesContent":[".App {\n  min-height: 100vh;\n}\n\n/* Marquee animation for client logos */\n@keyframes marquee {\n  0% { transform: translateX(0); }\n  100% { transform: translateX(-50%); }\n}\n.animate-marquee {\n  animation: marquee 30s linear infinite;\n}\n\n/* Subtle dotted background for sections */\n.bg-dots {\n  background-image: radial-gradient(rgba(15, 23, 42, 0.06) 1px, transparent 1px);\n  background-size: 24px 24px;\n}\n\n/* Gradient text helper */\n.text-gradient-green {\n  background: linear-gradient(90deg, #25D366 0%, #128C7E 100%);\n  -webkit-background-clip: text;\n  background-clip: text;\n  color: transparent;\n}\n\n/* Soft glow */\n.glow-green {\n  box-shadow: 0 20px 60px -20px rgba(37, 211, 102, 0.45);\n}\n\n/* Smooth scroll for in-page anchors */\nhtml { scroll-behavior: smooth; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
